/**
 * Overlay registry — maps x-overlay values to overlay implementations.
 * Add new overlays here as document types expand.
 */

import { runningBalanceOverlay } from './RunningBalanceOverlay';
import { investmentReconciliationOverlay } from './InvestmentReconciliationOverlay';

const OVERLAY_REGISTRY = {
  running_balance: runningBalanceOverlay,
  investment_reconciliation: investmentReconciliationOverlay,
};

export function getOverlay(overlayType) {
  return OVERLAY_REGISTRY[overlayType] || null;
}

export default OVERLAY_REGISTRY;
